<template>
<v-app>
    <Header/>
    <Login/>
    <Footer/>
</v-app>
</template>

<script>
    import Login from "./Login";
    import Header from "../HeaderPrelogin";
    import Footer from "../core/Footer";
    export default {
        name: "Index",
        components: {Login, Header, Footer}
    }
</script>

<style scoped>

</style>
